export default __webpack_public_path__ + "static/media/EBSLogo.fd8435ef.webp";